import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppStringsService } from 'src/app/_services';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-app-only',
    templateUrl: './app-only.component.html',
    styleUrls: ['./app-only.component.scss'],
    imports: [MatIconButton, MatIcon]
})
export class AppOnlyComponent {

    constructor(
        private dialogRef: MatDialogRef<AppOnlyComponent>,
        public appStringAPI: AppStringsService,
        @Inject(MAT_DIALOG_DATA) public data: string
    ) { }

    close() {
        this.dialogRef.close()
    }
}
